/* global mainScript */
import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";

import Loader from "../Helpers/Loader";
import Calendar from "./Calendar";
import CalendarDay from "./CalendarDay";

const CalendarPage = ({ctaTitle, ctaTextarea, messages}) => {
	const parsedMessages = messages ? JSON.parse((messages)) : null;

	const today = moment(new Date()).format("YYYY-MM-DD");
	const [date, setDate] = useState('');
	const [events, setEvents] = useState([]);
	const [skipCount, setSkipCount] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);
	const [showCalendar, setShowCalendar] = useState(false);
	const [apiKey, setApiKey] = useState(null);
	axios.defaults.withCredentials = true;

	useEffect(() => {

		// get value of sessionId cookie
		const dateCookie = ('; '+document.cookie).split(`; date=`).pop().split(';')[0];

		if (dateCookie) {
			// if date cookie, set date to previously visited
			setDate(moment(dateCookie).format('YYYY-MM-DD'))
		} else {
			// set the date to today on page load
			let today = new Date;
			today.setDate(today.getDate());
			setDate(moment(today).format('YYYY-MM-DD'));
		}

		axios
			.get(mainScript.tnewUrl)
			.then((res) => {
				setApiKey(res.data.encryptedSessionKey);
				axios
					.post(`/wp-json/fords/v1/cart/set_cookie`, {sessionId: res.data.encryptedSessionKey})
					.then(() => {
						const date = new Date();
						date.setTime(date.getTime()+(10*60*1000));
						document.cookie = `sessionId=${res.data.encryptedSessionKey}; expires=${date.toGMTString()}; path=/;`
					})
			})

	}, [])

	useEffect(() => {

		setIsLoading(true)
		setError(null)

		document.cookie = `date=${moment(date).format("YYYY-MM-DD")}; path=/;`

		// prevent request from firing twice
		if (skipCount) {
			setSkipCount(false)
		} else {
			// get calendar events
			axios
				.get(`/wp-json/fords/v1/calendar?date=${date}`)
				.then((res) => {
					if (res.data.events) {
						setEvents([...res.data.events]);
						setIsLoading(false);
					} else {
						setEvents([]);
						setIsLoading(false);
						setError(res.data.message);
					}
				})
				.catch((err) => {
					setEvents([]);
					setIsLoading(false);
					setError("There was an error", err)
				});
		}

	}, [date])

	const handleDateChange = (newDate) => {

		setDate(moment(newDate).format("YYYY-MM-DD"));

	}

	return (
		<div className="calendar-page">
			<div className="calendar-page__wrap">
				{isLoading ? <Loader/> :
					<CalendarDay
						apiKey={apiKey}
						date={date}
						error={error}
						events={events}
						setDate={setDate}
						today={today}
						showCalendar={showCalendar}
						setShowCalendar={setShowCalendar}
						messages={parsedMessages}
					/>
				}
				<Calendar
					ctaTitle={ctaTitle}
					ctaTextarea={ctaTextarea}
					date={date}
					handleDateChange={handleDateChange}
					showCalendar={showCalendar}
				/>
			</div>
		</div>
	)
}

export default CalendarPage;
